<mat-toolbar class="footer-toolbar">
  <current-user-string *ngIf="showCurrentUser"></current-user-string>
  <span class="spacer"></span>
  <app-version-string></app-version-string>
</mat-toolbar>
